export enum DsLayout {
    LIGHT_MODE = "lightMode",
    DARK_MODE = "darkMode"
}
export enum RoutePath {
    ROOT = "/",
    DASHBOARD = "/dashboard",
    CONTRACTS = "/contracts",
    //Internal route only to diffentiate contract home - see nav bar
    CONTRACTS_CUSTOMER_INFO = "/contracts/customer",
    CONTRACTS_CONTRACT_INFO = "/contracts/contract",
    //CONTRACTS_CUSTOMER_DATA = "/contracts/customer-data",
    //
    CONTRACTS_NEW_CUSTOMER = "/contracts/new-customer",
    CONTRACTS_EDIT_CUSTOMER = "/contracts/edit-customer",
    CONTRACTS_NEW_CONTRACT = "/contracts/new-contract",
    CONTRACTS_EDIT_CONTRACT = "/contracts/edit-contract",
    CONTRACTS_CUSTOMER_DELEGATION = "/contracts/delegate-customer",
    //transport
    CONTRACTS_TRANSPORTATORS_INFO = "/contracts/carriers", //CONTRACTS_TRANSPORTATORS_INFO = "/contracts/transportators",
    CONTRACTS_NEW_TRANSPORT = '/contracts/new-carrier',
    CONTRACTS_EDIT_TRANSPORT = "/contracts/edit-carrier",
    //Drivers
    CONTRACTS_DRIVER_INFO = "/contracts/drivers",
    CONTRACTS_NEW_DRIVER = '/contracts/new-driver',
    CONTRACTS_EDIT_DRIVER = "/contracts/edit-driver",
    //Vehicles
    CONTRACTS_VEHICLE_INFO = "/contracts/vehicles",
    CONTRACTS_NEW_DELEGATION = "/contracts/new-delegation",
    CONTRACTS_NEW_VEHICLE = "/contracts/new-vehicle",
    CONTRACTS_EDIT_VEHICLE = "/contracts/edit-vehicle",
    //update documents
    CONTRACTS_EDIT_DOCUMENT = "/contracts/edit-document",
    CONTRACTS_CUSTOMER_ISCC = "/contracts/iscc-customer",
    

    B2B = "/b2b",
    B2B_BOOKINGS_INFO = '/b2b/bookings',
    B2B_CHECKLIST = '/b2b/checklist',
    B2B_CLONE_RESERVATION = '/b2b/clone-reservation',
    B2B_CALENDAR = '/b2b/calendar',
    B2B_CALENDAR_SETTING = '/b2b/calendar-setting',

    PRE_BILLING = "/pre-billing",
    PRE_BILLING_INFO = "/pre-billing/billings",
    PRE_BILLING_EDIT = "/pre-billing/edit-billing",
    CONGUAGLIO = "/pre-billing/conguaglio",

    SETTINGS = '/settings',
    SETTINGS_SLOT_PARAMETERS = '/settings/slot-parameters',
    SETTINGS_FREEZING_SHORT = '/settings/freezing-short',
    SETTINGS_MOVE_PARAMETERS = '/settings/move-parameters',
    SETTINGS_SHIPPER_PARAMETERS = '/settings/shipper-parameters',
    SETTINGS_NEW_SHIPPER = '/settings/new-shipper',
    ISCC_DOCUMENT = "/contracts/delegate-customer",
}

/**
 *   Api Endpoints
 *  ***************
 */

/** Customers */
export const GET_CUSTOMER_DOMAIN = "/business-list-selector";//<--TO BE MOD IN selector as drivers 
export const GET_CUSTOMERS = "/business-list";
export const GET_CUSTOMER = "/get-business";
export const POST_CUSTOMER: string = "/business";
export const PUT_CUSTOMER: string = "/business";

/** Contracts */
export const GET_CONTRACTS = "/contract-list";
export const GET_CONTRACT = "/get-contract";
export const POST_CONTRACT = "/contract";
export const PUT_CONTRACT_INFO = "/contract";
export const ADD_DELEGATION = '/add-delegation'

/** Transporters */
export const GET_TRANSPORT = "/get-transporter";
export const POST_TRANSPORT = "/transporter";
export const GET_TRANSPORTS = "/transporter-list";
export const PUT_TRANSPORT_INFO = "/transporter";
export const DELETE_TRANSPORTER = "/delete-transporter";
export const CHANGE_STATUS = "/change-status";
export const DELETE_DELEGATION = "/delete";
export const ENABLE_DISABLE_DELEGATION = "/enable-disable-delegation";

export const SELECTOR = "/selector"
export const LOAD_ADDRESSES_OPTIONS = "/load-addresses-options"
export const CHECKLIST = "/checklist"
export const POST_CLONE_RESERVATION = "/clone-reservation"
export const GET_DELEGATING_CUSTOMERS = "/getDelegatingCustomers"
export const GET_DELEGATED_CUSTOMERS = "/getDelegatedCustomers"
export const GET_CLIENT_CONTRACTS = "/get-client-contracts"
export const CUSTOMER_DELEGATION = "/businessDelegation"
export const DELETE_CUSTOMER_DELEGATION = "/deleteCustomerDelegation"
export const GET_DELEGATION_BY_ID = "/getDelegationById";
export const CONGUAGLIO = "/settle"

export const POST_CUSTOMER_ISCC_DOCUMENT = "/iscc"
export const PUT_CUSTOMER_ISCC_DOCUMENT_STATUS = "/iscc-status"
export const DELETE_CUSTOMER_ISCC_DOCUMENT = "/delete-iscc"
export const GET_CUSTOMER_ISCC_DOCUMENT_BY_ID = "/iscc"
/** Drivers */
export const GET_TRANSPORTERS_DOMAIN = "/selector";
export const GET_DRIVERS = "/driver-list";
export const POST_DRIVER = "/driver";
export const GET_DRIVER = "/get-driver";
export const PUT_DRIVER_INFO = "/driver";

/** Vehicles */
export const GET_VEHICLES = "/vehicle-list";
export const GET_VEHICLE = "/get-vehicle";
export const POST_VEHICLE = "/vehicle";
export const PUT_VEHICLE_INFO = "/vehicle";

export const GET_DOCUMENT = "/get-document";
export const PUT_DOCUMENT = "/update-document";

/** Business, Contract and transporter info pdf download  */
export const DOWNLOAD_INFO = "/download-info";
/** Contract and transporter document pdf download  */
export const DOWNLOAD_DOCUMENT = "/download-document";
/** Delete an entity */
export const DELETE_ENTITY = "/delete";

/** B2b - calendar settings */
export const GET_CALENDAR_SETTINGS = "/calendar-settings";
export const PUT_CALENDAR_SETTINGS = "/calendar-settings";
export const GET_CALENDAR_EVENTS = "/calendar-slots";
export const GET_BAYES = "/bayes"
export const GET_CONTRACTS_SLOT = "/contracts-slot"
export const NON_WORKING_DAYS = "/non-working-days"

/* Settings parameter */
export const PARAMETERS_SLOT = "/parameters-slot"
export const PARAMETERS_FREEZING = "/parameters-freezing"
export const PUT_CALENDAR_TIMERANGE = "/calendar-timerange"
export const PUT_UNVAILABLE_BAYES = "/unavailable-bayes"
export const PUT_BOOK_SLOT = "/book-slot"
export const POST_SHIPPER = "/shipper"
export const GET_SHIPPER_LIST = "/shipper-list"
export const MOVE_RESERVATION_PARAMS = "/move-reservation-parameters"

/** Reservations */
export const GET_BOOKINGS = "/reservation-list";
export const GET_BOOKING = "/reservation";
export const POST_BOOKING = "/reservation";
export const GET_BUSINESS_VEHICLE = "/business-vehicle"
export const PREBILLING_REPORT = '/report'
export const GET_VALUE_TAKEORPAY = '/value-take-or-pay'
export const GET_BUSINESS_SETTLE = "/business-settle"
export const GET_CONTRACTS_SETTLE = "/contract-settle"

/** Authentication */
export const GET_USER_DATA = "/get-user-info";

export enum RequestStatus {
    PRISTINE = "pristine",
    PENDING = "pending",
    SUCCESS = "success",
    ERROR = "error"
}
export enum ResponseStatus {
    SUCCESS = "OK",
    ERROR = "KO"
}
export enum ResponseCode {
    SUCCESS = "200",
    UNPROCESSABLE_CONTENT = "422"
}

export enum ReservationPostType {
    UPDATE_DETAILS = "update-details",
    POST_CLOSE = "post-close",
}

export enum UICommand {
    RELOAD = "reload",
    EDIT = "edit",
    DELETE = "delete",
    DOWNLOAD = "download",
    APPROVE = 'approve',
    REJECT = 'reject',
    CREDIT = 'credit',
    CREDIT_SALES = 'credit_sales',
    REJECT_CREDIT = 'reject_credit',
    CALENDAR_SLOT_NOT_AVAILABLE = 'calendar_slot_not_available',
    CALENDAR_CONFIGURE = 'calendar_configure',
    CALENDAR_DELETE_SLOTS = 'calendar_delete_slots',
    CALENDAR_PUBBLICATION = 'calendar_pubblication',
    CALENDAR_DELETE_PUBBLICATION = 'calendar_delete_pubblication',
    CALENDAR_BOOK_SLOT = 'calendar_book_slot',
    CALENDAR_BOOK_SLOT_ERROR = 'calendar_book_slot_error',
    CALENDAR_NON_WORKING_DAYS_INSERT = 'CALENDAR_NON_WORKING_DAYS_INSERT',
    CALENDAR_NON_WORKING_DAYS_DELETE = 'CALENDAR_NON_WORKING_DAYS_DELETE',
    CALENDAR_MOVE_RESERVATION = 'CALENDAR_MOVE_RESERVATION',
    REVERT_RESERVATIONS = "REVERT_RESERVATIONS"
}
export const DATE_FORMAT: string = "DD/MM/YYYY";
export const TIME_FORMAT: string = "HH:mm";
export const ULTRA_LATE_DATE : number = 32472144000; //01/01/2999
export enum BadgeStatus {
    VALID = 0,
    EXPIRED = 1,
    TOAPPROVE = 2, 
    APPROVED = 3,
    NOTAPPROVED = 4,
    TO_CREDIT = 5,
    CREDITED = 6, 
    NOT_CREDITED = 7,
    ACCREDITED_SALES = 8, //il commerciale ha accreditato
}


export enum ClientType {
    IT = "0",
    UE = "1",
    EXTRA_UE = "2"
}
export interface IClientTypeData {
    label: string,
    value: ClientType
}
export const ClientTypes: Map<ClientType, IClientTypeData> = new Map();
ClientTypes.set(ClientType.IT, { label: "IT", value: ClientType.IT });
ClientTypes.set(ClientType.UE, { label: "UE", value: ClientType.UE });
ClientTypes.set(ClientType.EXTRA_UE, { label: "Extra UE", value: ClientType.EXTRA_UE });

export enum LanguageKey {
    IT = "it",
    EN = "en"
}
export interface ILanguage {
    id: LanguageKey,
    label: string
}

export const LANGUAGES: Map<string, ILanguage> = new Map();
LANGUAGES.set(LanguageKey.IT, { id: LanguageKey.IT, label: "Ita" });
LANGUAGES.set(LanguageKey.EN, { id: LanguageKey.EN, label: "Eng" });

export enum FormMode {
    NEW,
    EDIT,
    READ
}

export enum EntityType {
    CONTRACT = "contract",
    TRANSPORTER = "transporter",
    DRIVER = "driver",
    VEHICLE = "vehicle",
    TRANSPORTERDELEGATION = "transporterDelegation",
    BUSINESS = 'business',
    CALENDAR = 'calendar',
    SHIPPER = 'shipper',
    RESERVATION = 'reservation',
    SERVICE = 'service',
    BAY = 'bay',
    DASHBOARD='dashboard',
    BOOKING='booking',
    COOKIE='cookie',
    CHECKLIST='checklist',
    PRIVACYPOLICY='PRIVACYPOLICY',
    PENTASCADA_DDT = 'PENTASCADADDT',
    CUSTOMERDELEGATION='customerDelegation',
    TMAC_DDT = 'TMACDDT',
    ISCC_DOCUMENT = 'CUSTOMERISCCDOCUMENT'
}
export enum DocumentType {
    CONTRACT = "contract",
    SECURITY_TEMPLATE = "securityTemplate",
    TRUCK_INSPECTION = "truckInspection",
    //certificato ADR 
    ADR_DECLARATION = "adrDeclaration",
    IDENTITY_CARD = "identityCard",
    FISCAL_CODE = "fiscalCode",
    DRIVE_LICENCE = "driveLicense",
    PERSONAL_DATA = "personalData",
    QUALIFICATION_DRIVER = "qualificationDriver",
    FREQUENCY_CERTIFICATE = "frequencyCertificate",
    //Vehicle (plus adrDeclaration)
    //certificato assicurazione RCA
    INSURANCE_CERTIFICATE = "insuranceCertificate",
    // Libretto di immatricolazione
    REGISTRATION_DOCUMENT = "registrationDocument",
    //revisione veicolo
    TECHNICAL_CHECK = "technicalCheck",
    //certificato test iniziale o periodico 
    TEST_CERTIFICATE = "testCertificate",
    //procedure di carico, scarico e raffreddamento
    PROCEDURES = "procedures",
    PID = "pidPfd",
    //disegno meccanico 
    GA_DRAWING = "gaDrawing",
    //certificazione per rompifiamma 
    FLAME_ARREST = "flameArrest",
    DELEGATION = "delegation",
    COOKIE = 'cookie',
    CHECKLIST = 'checklist',
    PRIVACYPOLICY='PRIVACYPOLICY',
    EMPTY_FILE="emptyFile.pdf",
    PENTASCADA_DDT_DOC = 'PENTASCADADDT',
    CUSTOMER_DELEGATION = "customerDelegation",
    TMAC_DDT_DOC = "TMACDDT",
    CUSTOMER_ISCC_DOCUMENT="ISCC"
}

export enum VehicleType {
    TRUCK = 0,//Motrice
    TANKER = 1,//autobotte
    ISO_CONTAINER = 2,
    FLOOR = 3//Pianale
}

export enum Direction {
    RIGHT,
    LEFT,
    BOTTOM/*,
    TOP*/
}
export enum Affirmation {
    NO = "0",
    YES = "1"
}

export enum CalendarViewType {
    //draft: 1 per gli slot in draft del calendario provvisorio – 0 per gli slot del calendario pubblico 
    PUBLIC,
    DRAFT
}
export enum CalendarMode {
    DAY,
    WEEK,
    MONTH
}
export enum CalendarSlotStatus {
    AVAILABLE = "0",
    CONFIRMED = "1",
    PENDING = "2",
    REJECTED = "3",
    BUSY = "4",
    UNAVAILABLE = "5",
    CLOSED = "6", //GRIGIO
    CANCELLED = "7", //se la reservation viene cancellata dal pulsante "elimina reservation" // NERO
    SLOT_DELETED = "8", // se la reservation viene cancellata quando si elimina una pubblicazione // MARRONE
    NON_WORKING_DAY = "9",
    VACANT = "10", //reservation vacante
}

export enum SupplyingResultIdStatus {
    UNKNOWN = 5, //Valore iniziale
    POSITIVE = 0, //Indica se è stata chiusa con esito positivo
    NEGATIVE = 4, //Indica se è stata chiusa con esito negativo
    FTT = 1, //Failure to take
    FTD = 2, //Failure to delivery
    CANCELED = 3 //Annullato
}

//Badge status for jarvis on booking
export enum JarvisStatus {
    OK,
    KO,
    PENDING
}

/** Snam plants */
export enum SnamPlantKey {
    PANIGAGLIA = "1",
    PIGNATARO = "2"
}
export interface ISnamPlant {
    id: SnamPlantKey,
    label: string
}
export const SNAM_PLANTS: Map<SnamPlantKey, ISnamPlant> = new Map([
    [SnamPlantKey.PANIGAGLIA, { id: SnamPlantKey.PANIGAGLIA, label: "Panigaglia" }]//to do: translate
]);

/** 
 * ================================================================================================================
 * Use to add a series of file input in loop, separated by form steps, and to review them on input review
 * ================================================================================================================
 */
export interface IFileInputConfig {
    id: number,
    step: number,
    documentType: DocumentType,
    expireRequired: boolean
}

export const getDriverFileInputConfig = () => {
    const fileInputConfig: IFileInputConfig[] = [
        //Carta di identità
        { id: 0, step: 2, documentType: DocumentType.IDENTITY_CARD, expireRequired: true },
        //Codice fiscale
        { id: 1, step: 2, documentType: DocumentType.FISCAL_CODE, expireRequired: true },
        //Patente di guida
        { id: 2, step: 2, documentType: DocumentType.DRIVE_LICENCE, expireRequired: true },
        //Autorizzazione del trattamento dei dati personali
        { id: 3, step: 2, documentType: DocumentType.PERSONAL_DATA, expireRequired: false },
        //CQC Carta Qualificazione Conducente
        { id: 4, step: 3, documentType: DocumentType.QUALIFICATION_DRIVER, expireRequired: true },
        //Certificazione ADR
        { id: 5, step: 3, documentType: DocumentType.ADR_DECLARATION, expireRequired: true },
        //Attestato di frequenza e idoneità del corso formativo erogato dall'operatore
        { id: 6, step: 3, documentType: DocumentType.FREQUENCY_CERTIFICATE, expireRequired: true },
    ];
    return fileInputConfig;
}
export const getVehicleFileInputConfig = (vehicleType: VehicleType, flameArrest: Affirmation) => {
    const allFileInputConfig: IFileInputConfig[] = [
        { id: 0, step: 2, documentType: DocumentType.REGISTRATION_DOCUMENT, expireRequired: false },
        { id: 1, step: 2, documentType: DocumentType.TECHNICAL_CHECK, expireRequired: true },
        { id: 2, step: 2, documentType: DocumentType.PID, expireRequired: false },
        { id: 3, step: 2, documentType: DocumentType.GA_DRAWING, expireRequired: false },
        { id: 4, step: 3, documentType: DocumentType.PROCEDURES, expireRequired: false },
        { id: 5, step: 4, documentType: DocumentType.INSURANCE_CERTIFICATE, expireRequired: true },
        { id: 6, step: 4, documentType: DocumentType.ADR_DECLARATION, expireRequired: true },
        { id: 7, step: 4, documentType: DocumentType.TEST_CERTIFICATE, expireRequired: true },
        { id: 8, step: 4, documentType: DocumentType.FLAME_ARREST, expireRequired: false }
    ];

    //Document list is filtered by vehicle type and flame arrest
    let excludeList: DocumentType[];
    switch (vehicleType) {
        case VehicleType.TRUCK:
            excludeList = [
                DocumentType.PROCEDURES,
                DocumentType.PID
            ];
            if (flameArrest === Affirmation.YES) {//"1"-SI
                excludeList.push(DocumentType.FLAME_ARREST)
            }
            break;
        case VehicleType.TANKER:
            excludeList = [
                DocumentType.FLAME_ARREST
            ];
            break;
        case VehicleType.ISO_CONTAINER:
            excludeList = [
                DocumentType.INSURANCE_CERTIFICATE,
                DocumentType.REGISTRATION_DOCUMENT,
                DocumentType.TECHNICAL_CHECK,
                DocumentType.FLAME_ARREST
            ];
            break;
        case VehicleType.FLOOR:
            excludeList = [
                DocumentType.PROCEDURES,
                DocumentType.PID,
                DocumentType.FLAME_ARREST

            ];
            break;
        default:
            excludeList = [];
            break;
    }
    const fileInputConfig: IFileInputConfig[] = allFileInputConfig.filter((fileInputObj: IFileInputConfig) => {
        return excludeList.indexOf(fileInputObj.documentType) === -1;
    });

    return fileInputConfig;

}


/**======================================================================================================================== */


/**======================
 * User roles & profiles
 *=======================
 */
//Specific grants (user for reservations, checklist and calendar)
export enum AppUserGrant{
    READ,
    EDIT,
    DELETE,
    APPROVE,
    REJECT,
    CLONE,
    BOOK_SLOT,
    RATE_SLOT,//Slot outcome
    CLOSE_SLOT,//Closure with negative outcome (failure to...)
    //dashboard grants
    CALENDAR_MENU,
    CALENDAR,
    CONTRACT_SLOT_CHART,
    BOOKING_LIST,
    VEHICLE_LIST,
    TRANSPORTER_DELEGATION_LIST,
}
// Each app user profile data model
export interface IAppUserProfile {
    id: number,
    labelKey: string, //for translation
    administrator: boolean, //unused, for now...
    /** POLICIES */
    /** Menu items */
    dashboardMenuItem:boolean,
    contractsMenuItem:boolean,
    b2bMenuItem:boolean,
    prebillingMenuItem:boolean,
    settingsMenuItem:boolean,
    /** Profile catch all feature policies */
    addEntityPolicy:EntityType[],//can insert entities
    editEntityPolicy:EntityType[],//can edit entities
    deleteEntityPolicy:EntityType[],//can delete entities
    approveEntityPolicy:EntityType[]//can approve entities
    /** Other grants */
    reservationGrants:AppUserGrant[],//Grants for reservations
    checklistGrants:AppUserGrant[],//Grants for checklist
    calendarGrants:AppUserGrant[],//Grants for calendar,
    dashboardGrants:AppUserGrant[]//Grants for dashboard
    prebillingGrants:AppUserGrant[]//Grants for dashboard
}
//All app autenticated user roles
export enum AppUserRole {
    //Commerciale
    SALES_PROFILE = "SalesProfile",
    TL_MANAGER = "TLManager",
    //Operatore baia
    BAY_OPERATOR = "BayOperator",
    //Cliente
    CUSTOMER = "Customer",
    //Personale
    EMPLOYEE = "Employee",
    //Operatore Roro
    RORO_EMPLOYEE = "ROROEmployee",
    //Trasportatore
    CARRIER = "Carrier",
    //ADMIN
    ADMIN = "Admin",
    //Reader
    READER = "Reader",
    MONITORING_AGENT = "MonitoringAgent"/*,
    USER_MANAGER = "UserManager",
    JARVIS_OPERATOR = "JarvisOperator",
    TMAC_OPERATOR = "TMACOperator"*/,
    SHIP_MANAGER = "ShipManager",
    PROPERTY_AND_CASUALTY = "Property and Casuality",
    ACCESS_STAFF = "AccessStaff"
}

//Map for each user and their roles with grants and policies.
export const APP_USER_PROFILES: Map<string, IAppUserProfile> = new Map();

//Commerciale
APP_USER_PROFILES.set(AppUserRole.SALES_PROFILE,
    {
        id: 0,
        labelKey: "salesProfile",
        administrator: true,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:true,
        settingsMenuItem:true,
        addEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        editEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.TRANSPORTERDELEGATION,
            EntityType.CUSTOMERDELEGATION
        ],
        deleteEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        approveEntityPolicy:[
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.CLOSE_SLOT,
            AppUserGrant.CLONE
        ],
        checklistGrants:[
            AppUserGrant.READ
        ],
        calendarGrants:[
            AppUserGrant.READ,
            AppUserGrant.BOOK_SLOT,
            AppUserGrant.DELETE
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.CONTRACT_SLOT_CHART,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ]
    }
);

//MonitoringAgent
APP_USER_PROFILES.set(AppUserRole.MONITORING_AGENT,
    {
        id: 0,
        labelKey: "MonitoringAgent",
        administrator: false,
        dashboardMenuItem:false,
        contractsMenuItem:false,
        b2bMenuItem:false,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[
           
        ],
        editEntityPolicy:[
            
        ],
        deleteEntityPolicy:[
            
        ],
        approveEntityPolicy:[
           
        ],
        reservationGrants:[
            
        ],
        checklistGrants:[
            
        ],
        calendarGrants:[
           
        ],
        dashboardGrants:[
           
        ],
        prebillingGrants:[
            
        ]
    }
);

//TL Manager
APP_USER_PROFILES.set(AppUserRole.TL_MANAGER,
    {
        id: 1,
        labelKey: "TL_Manager",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[],
        editEntityPolicy:[],
        deleteEntityPolicy:[],
        approveEntityPolicy:[
            EntityType.DRIVER, 
            EntityType.VEHICLE
        ],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.RATE_SLOT,
            AppUserGrant.CLONE
        ],
        checklistGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ],
        calendarGrants:[
            AppUserGrant.READ,
            AppUserGrant.DELETE
        ],
        dashboardGrants:[
            //AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.VEHICLE_LIST,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Operatore di baia
APP_USER_PROFILES.set(AppUserRole.BAY_OPERATOR,
    {
        id: 2,
        labelKey: "bayOperator",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:false,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[],
        editEntityPolicy:[],
        deleteEntityPolicy:[],
        approveEntityPolicy:[],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
        ],
        checklistGrants:[],
        calendarGrants:[
            AppUserGrant.READ
        ],
        dashboardGrants:[
            //AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Cliente
APP_USER_PROFILES.set(
    AppUserRole.CUSTOMER,
    {
        id: 3,
        labelKey: "customer",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:true,
        settingsMenuItem:false,
        addEntityPolicy:[
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        editEntityPolicy:[
            EntityType.TRANSPORTERDELEGATION,
            EntityType.CUSTOMERDELEGATION
        ],
        deleteEntityPolicy:[
            EntityType.CUSTOMERDELEGATION
        ],
        approveEntityPolicy:[],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.CLONE
        ],
        checklistGrants:[],
        calendarGrants:[
            AppUserGrant.READ,
            AppUserGrant.BOOK_SLOT
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.CONTRACT_SLOT_CHART,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Personale LS
APP_USER_PROFILES.set(AppUserRole.EMPLOYEE,
    {
        id: 4,
        labelKey: "employee",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:false,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[],
        editEntityPolicy:[],
        deleteEntityPolicy:[],
        approveEntityPolicy:[],
        reservationGrants:[
            AppUserGrant.READ
        ],
        checklistGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ],
        calendarGrants:[
            AppUserGrant.READ
        ],
        dashboardGrants:[
            //AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Personale Roro
APP_USER_PROFILES.set(AppUserRole.RORO_EMPLOYEE,
    {
        id: 5,
        labelKey: "RORO_Employee",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:false,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[],
        editEntityPolicy:[],
        deleteEntityPolicy:[],
        approveEntityPolicy:[],
        reservationGrants:[
            AppUserGrant.READ,
        ],
        checklistGrants:[],
        calendarGrants:[
            AppUserGrant.READ
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Trasportatore
APP_USER_PROFILES.set(AppUserRole.CARRIER,
    {
        id: 6,
        labelKey: "carrier",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[
            EntityType.DRIVER, 
            EntityType.VEHICLE
        ],
        editEntityPolicy:[
            EntityType.TRANSPORTER, 
            EntityType.DRIVER,
            EntityType.VEHICLE
        ],
        deleteEntityPolicy:[
            EntityType.DRIVER,
            EntityType.VEHICLE
        ],
        approveEntityPolicy:[],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.CLONE
        ],
        checklistGrants:[],
        calendarGrants:[
            AppUserGrant.READ,
            AppUserGrant.BOOK_SLOT
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.TRANSPORTER_DELEGATION_LIST,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);

//Admin
APP_USER_PROFILES.set(AppUserRole.ADMIN,
    {
        id: 7,
        labelKey:"administrator",
        administrator: true,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:true,
        settingsMenuItem:true,
        addEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        editEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.TRANSPORTERDELEGATION,
            EntityType.CUSTOMERDELEGATION
        ],
        deleteEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        approveEntityPolicy:[
            EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE,
            EntityType.CUSTOMERDELEGATION
        ],
        reservationGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.RATE_SLOT,
            AppUserGrant.CLOSE_SLOT,
            AppUserGrant.CLONE
        ],
        checklistGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ],
        calendarGrants:[
            AppUserGrant.READ,
            AppUserGrant.BOOK_SLOT,
            AppUserGrant.DELETE
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.CONTRACT_SLOT_CHART,
            AppUserGrant.BOOKING_LIST,
            //AppUserGrant.VEHICLE_LIST,
            //AppUserGrant.TRANSPORTER_DELEGATION_LIST
        ],
        prebillingGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ]
    }
);

//Reader
APP_USER_PROFILES.set(AppUserRole.READER,
    {
        id: 8,
        labelKey:"reader",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:true,
        b2bMenuItem:true,
        prebillingMenuItem:true,
        settingsMenuItem:true,
        addEntityPolicy:[
            /*EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE*/
        ],
        editEntityPolicy:[
            /*EntityType.BUSINESS, 
            EntityType.CONTRACT, 
            EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE*/
        ],
        deleteEntityPolicy:[
            /*EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE*/
        ],
        approveEntityPolicy:[
            /*EntityType.TRANSPORTER, 
            EntityType.DRIVER, 
            EntityType.VEHICLE*/
        ],
        reservationGrants:[
            AppUserGrant.READ,
            /*
            AppUserGrant.EDIT,
            AppUserGrant.DELETE,
            AppUserGrant.RATE_SLOT,
            AppUserGrant.CLOSE_SLOT*/
        ],
        checklistGrants:[
            AppUserGrant.READ,
            /*AppUserGrant.EDIT,
            */
        ],
        calendarGrants:[
            AppUserGrant.READ,
            /*AppUserGrant.BOOK_SLOT,
            AppUserGrant.DELETE*/
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.CONTRACT_SLOT_CHART,
            AppUserGrant.BOOKING_LIST,
            //AppUserGrant.VEHICLE_LIST,
            //AppUserGrant.TRANSPORTER_DELEGATION_LIST
        ],
        prebillingGrants:[
            AppUserGrant.READ,
            //AppUserGrant.EDIT
        ]
    }
);

//Ship Manager
APP_USER_PROFILES.set(AppUserRole.SHIP_MANAGER,
    {
        id: 9,
        labelKey: "ShipManager",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:false,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[
        ],
        editEntityPolicy:[
        ],
        deleteEntityPolicy:[
        ],
        approveEntityPolicy:[
        ],
        reservationGrants:[
            AppUserGrant.READ
        ],
        checklistGrants:[
        ],
        calendarGrants:[
            AppUserGrant.READ
        ],
        dashboardGrants:[
            AppUserGrant.CALENDAR_MENU,
            AppUserGrant.CALENDAR,
            AppUserGrant.BOOKING_LIST
        ],
        prebillingGrants:[
        ]
    }
);



//Property and Casualty
APP_USER_PROFILES.set(AppUserRole.PROPERTY_AND_CASUALTY,
    {
        id: 10,
        labelKey: "Property and Casuality",
        administrator: false,
        dashboardMenuItem:true,
        contractsMenuItem:false,
        b2bMenuItem:false,
        prebillingMenuItem:true,
        settingsMenuItem:false,
        addEntityPolicy:[
        ],
        editEntityPolicy:[
        ],
        deleteEntityPolicy:[
        ],
        approveEntityPolicy:[
        ],
        reservationGrants:[
        ],
        checklistGrants:[
        ],
        calendarGrants:[
        ],
        dashboardGrants:[
        ],
        prebillingGrants:[
            AppUserGrant.READ,
            AppUserGrant.EDIT
        ]
    }

    
);

//Access Staff
APP_USER_PROFILES.set(AppUserRole.ACCESS_STAFF,
    {
        id: 11,
        labelKey:"AccessStaff",
        administrator: false,
        dashboardMenuItem:false,
        contractsMenuItem:false,
        b2bMenuItem:true,
        prebillingMenuItem:false,
        settingsMenuItem:false,
        addEntityPolicy:[
            
        ],
        editEntityPolicy:[
           
        ],
        deleteEntityPolicy:[
          
        ],
        approveEntityPolicy:[
            
        ],
        reservationGrants:[
            AppUserGrant.READ,
        ],
        checklistGrants:[
        ],
        calendarGrants:[
            
        ],
        dashboardGrants:[
           
        ],
        prebillingGrants:[
            
        ]
    }
);